import { createContext } from "react";
import { DARK, LIGHT } from "constants/appModes";

export const AppThemeGradientContext = createContext({
  values: { [LIGHT]: [], [DARK]: [] },
  setValues: (values) => values,
});
